import { Component, EventEmitter, Output } from '@angular/core';
import { environment } from '@environments/environment';
import { TrapFocusDirective } from '@shared/directives/trap-focus.directive';

@Component({
    selector: 'app-menu-services[closePopover]',
    templateUrl: './menu-services.component.html',
    styleUrls: ['./menu-services.component.scss'],
    imports: [TrapFocusDirective],
    standalone: true,
})
export class MenuServicesComponent {
    @Output() closePopover: EventEmitter<void> = new EventEmitter<void>();

    readonly geneticMonitoringUrl = environment.geneticMonitoringUrl;
    readonly microbiomeUrl = environment.microbiomeUrl;
    readonly colonyUrl = environment.colonyUrl;
    readonly tagCenterUrl = 'https://tagcenter.info/';

    close(): void {
        this.closePopover.emit();
    }
}
